import { fmt } from 'components/IntlWrapper/IntlWrapper';
import ArmChair from 'assets/bosta-icons/Armchair.svg';
import BaseballCap from 'assets/bosta-icons/BaseballCap.svg';
import Dress from 'assets/bosta-icons/Dress.svg';
import ShirtFolded from 'assets/bosta-icons/ShirtFolded.svg';
import Sneaker from 'assets/bosta-icons/Sneaker.svg';
import Sunglasses from 'assets/bosta-icons/Sunglasses.svg';
import TShirt from 'assets/bosta-icons/TShirt.svg';
import Footprints from 'assets/bosta-icons/Footprints.svg';
import MessengerPlatformIcon from 'assets/bosta-icons/connectMessanger.svg';
import InstagramPlatformIcon from 'assets/bosta-icons/instagramColored.svg';
import CustomerManualGif from 'assets/bosta-images/coustomerChats.gif';
import MerchantManualGif from 'assets/bosta-images/merchantChat.gif';
import ManualFlowCustomerManualGif from 'assets/bosta-images/ManualFlow-Shopper.gif';
import ManualFlowMerchantManualGif from 'assets/bosta-images/ManualFlow-Merchant.gif';
import { ReactComponent as Product } from 'assets/bosta-icons/Product.svg';
import { ReactComponent as Location } from 'assets/bosta-icons/Location.svg';
import { ReactComponent as ShoppingCart } from 'assets/icons/shopping-cart.svg';
import { ReactComponent as CollectInfo } from 'assets/icons/collect-info.svg';
import { ReactComponent as MediaIcon } from 'assets/bosta-icons/mediaIcon.svg';

export const MESSAGE_TYPE = [
  {
    value: 'RESPONSE',
    label: 'chats_plugins.chats_page.Message_type_labels.response'
  },
  {
    value: 'UPDATE',
    label: 'chats_plugins.chats_page.Message_type_labels.update'
  },
  {
    value: 'MESSAGE_TAG',
    label: 'chats_plugins.chats_page.Message_type_labels.tag'
  }
];

export const MESSAGE_TAGS = [
  {
    value: 'ACCOUNT_UPDATE',
    label: 'chats_plugins.chats_page.message_tag.account_update'
  },
  {
    value: 'CONFIRMED_EVENT_UPDATE',
    label: 'chats_plugins.chats_page.message_tag.confirm_update'
  },
  {
    value: 'CUSTOMER_FEEDBACK',
    label: 'chats_plugins.chats_page.message_tag.customer_feedback'
  },
  {
    value: 'HUMAN_AGENT',
    label: 'chats_plugins.chats_page.message_tag.human_agent'
  },
  {
    value: 'POST_PURCHASE_UPDATE',
    label: 'chats_plugins.chats_page.message_tag.post_purchase_update'
  }
];

export const PAGE_ID = '114263078435315';
export const PAGE_ACCESS_TOKEN =
  'EAAXpg6FcgtQBO4lsl69MMDeohI109arYL3dic2O0WBZCbQZBZCDHstoaZCP5kD07nHKC7jd7TMED0QFvNZCwbN7xmDzOaRgsVusBgBHNC1f3CGLPNPWbmrWxILEEUXqZBZCp3A7UnZA4LPdeUx8b3mblFdSo085GjAHZCEZB5WIEwmSjP1K3gqmzq0VpsY6yKXxdAZD';

export const ALL = 'All';
export const MESSENGER = 'messenger';
export const FACEBOOK = 'facebook';
export const WHATSAPP = 'whatsapp';
export const IMAGE_TYPE = 'image';
export const VIDEO_TYPE = 'video';
export const AUDIO_TYPE = 'audio';
export const TEXT_TYPE = 'text';
export const FILE_TYPE = 'file';
export const MEDIA = 'media';
export const LOCATION_TYPE = 'location';
export const DOCUMENTS_TYPE = 'application';
export const DEFAULT_AUDIO_TYPE = 'audio/ogg';
export const DEFAULT_VIDEO_TYPE = 'video/mp4';
export const INSTAGRAM = 'instagram';
export const INTERACTIVE = 'interactive';
export const ATTACHMENT = 'attachment';
export const BUSINESS = 'business';
export const TEST_API = 'Testapi';
export const SYSTEM = 'system';
export const ASSIGNEE_TYPE = 'chatAssigned';
export const UNASSIGNEE_TYPE = 'chatUnassigned';

export const CATEGORY_TYPE = {
  START: 'start',
  MIDDLE: 'middle',
  END: 'end'
};

export const PLATFORMS = [
  { key: 'all', value: 'chats_plugins.chats_page.platforms.all' },
  { key: 'messenger', value: 'chats_plugins.chats_page.platforms.messenger' },
  { key: 'whatsapp', value: 'chats_plugins.chats_page.platforms.whatsApp' },
  {
    key: 'instagram',
    value: 'chats_plugins.chats_page.platforms.instagram'
  }
];

export const HEADER_PLATFORM = {
  MESSENGER: {
    platformIcon: MessengerPlatformIcon,
    platform: 'chats_plugins.chats_page.platforms.messenger',
    description: 'chats_plugins.chats_page.connect_facebook_to_sllr'
  },
  INSTAGRAM: {
    platformIcon: InstagramPlatformIcon,
    platform: 'chats_plugins.chats_page.platforms.instagram',
    description: 'chats_plugins.chats_page.connect_instagram_to_sllr'
  }
};

export const MAX_PRODUCTS_PER_TIME = 10;

export const EMPTY_STATE_MESSENGER_CARDS = {
  default: [
    {
      title: 'chats_plugins.chats_page.one_place_for_messages',
      description: 'chats_plugins.chats_page.reply_to_your_coustomer'
    },
    {
      title: 'chats_plugins.chats_page.share_products_directly',
      description: 'chats_plugins.chats_page.share_products_from_sllr'
    },
    {
      title: 'chats_plugins.chats_page.sell_on_FB',
      description: 'chats_plugins.chats_page.collect_delivery_info'
    }
  ],
  failed: [
    {
      title: 'chats_plugins.chats_page.popup_connection',
      description: 'chats_plugins.chats_page.enable_popup'
    },
    {
      title: 'chats_plugins.chats_page.facebook_page_issue',
      description: 'chats_plugins.chats_page.page_permissions'
    },
    {
      title: 'chats_plugins.chats_page.instagram_page_issue',
      description: 'chats_plugins.chats_page.instagram_permissions'
    }
  ]
};

export const MOBILE_EMPTY_STATE_MESSENGER_CARDS = [
  {
    title: 'chats_plugins.chats_page.share_products_directly_to_FB',
    description: 'chats_plugins.chats_page.share_products_with_customers'
  },
  {
    title: 'chats_plugins.chats_page.sell_on_FB',
    description: 'chats_plugins.chats_page.not_let_customers_leave_chat'
  },
  {
    title: 'chats_plugins.chats_page.communicate_with_customers',
    description: 'chats_plugins.chats_page.communicate_customers_through_FB'
  }
];

export const START = 'start';
export const MIDDLE = 'middle';
export const END = 'end';

export const FAILED = 'failed';
export const READ = 'read';
export const SEND = 'send';
export const PENDING = 'pending';
export const DELIVERED = 'delivered';
export const SENT = 'sent';

export const MESSAGE_STATUSES = {
  PENDING: 'pending',
  DELIVERED: 'delivered',
  READ: 'read',
  DELETED: 'deleted',
  FAILED: 'failed',
  SENT: 'sent'
};
export const MAX_UNREAD_MESSAGES = 9;

export const DEFAULT_DATA = Array.from({
  length: 2
}).map((_, i) => ({
  userName: '',
  id: i
}));

export const SHARED_ONE_VARIANCE = 1;

export const LARGE_WIDE_SCREEN_CARDS = 5;
export const WIDE_SCREEN_CARDS = 4;
export const XLARGE_SCREEN_CARDS = 3;
export const LARGE_SCREEN_CARDS = 2;
export const MOBILE_SCREEN_CARDS = 1;

export const PRODUCT_CARD_WIDTH = 240;

export const PRODUCTS_PLACEHOLDER = [
  { placeholderImage: BaseballCap },
  { placeholderImage: Footprints },
  { placeholderImage: Dress },
  { placeholderImage: Sunglasses },
  { placeholderImage: Sneaker },
  { placeholderImage: ShirtFolded },
  { placeholderImage: ArmChair },
  { placeholderImage: TShirt },
  { placeholderImage: Footprints },
  { placeholderImage: Sneaker }
];

export const NUMBER_OF_DEFAULT_IMAGES = 8;

export const PRODUCT_ADDED_MESSAGE = '7';
export const VIEW_CART_CODE_MESSAGE = '10';
export const SHOW_VIEW_CART_CODE_MESSAGE = '11';
export const EMPTY_CART_MESSAGE_CODE = '14';
export const REMOVE_MESSAGE_CODE = '16';
export const SHARED_VARIANCE_MESSAGE = '19';
export const COLLECT_NAME_CODE = '27';
export const BOT_COLLECT_ADDRESS_CODE_MESSAGE = '29';
export const PLACE_ORDER_MESSAGE_CODE = '31';
export const ORDER_SUMMARY_MESSAGE = '33';
export const VIEW_ORDER = '35';
export const COLLECT_FIRST_LINE = '44';
export const COLLECT_PHONE_CODE = '48';
export const VIEW_DETAILS_CODE_MESSAGE = '55';
export const HAVE_PROBLEM_CODE_MESSAGE = '56';
export const ORDER_NOTES = 'orderNote';
export const ORDER_NOTES_STATUS = 'orderNote status';
export const VIEW_IMAGE_CODE_MESSAGE = 'view_image';

//ACTIONS
export const ADD_NEW_ITEM_ACTION = 'ADD_NEW_ITEM';
export const COLLECT_CUSTOMER_INFO_ACTION = 'ADD_DELIVERY_ADDRESS';

export const COLLECT_SHIPPING_INFO = 'collect shipping info';
export const COLLECT_CUSTOMER_INFO = 'collect customer info';
export const SEND_CART = 'send cart';
export const ADD_PRODUCT = 'add product';
export const CHATS = 'chats';
export const SHARE_MEDIA = 'share media';

export const CONFIRM_ORDER = 'confirm order';
export const DELETE_ORDER = 'delete order';
export const DRAFT_ORDER = 'draft order';

export const ADD_DELIVERY_ADDRESS = 'Add delivery address';
export const ADD_DELIVERY_ADDRESS_AR = 'إضافة عنوان التوصيل';
export const BOT = 'bot';
export const MANUALLY = 'manually';

export const SHARE_PRODUCTS_BUTTONS = {
  en: {
    VIEW_DETAILS: 'Send details',
    ADD_TO_CART: 'Add to customer’s cart',
    CHOOSE_OPTION: 'Send Product Options'
  },
  ar: {
    VIEW_DETAILS: 'إرسال التفاصيل',
    ADD_TO_CART: 'أضف الي سله المشتريات',
    CHOOSE_OPTION: 'إرسال خيارات المنتج'
  }
};

export const MULTIPLE_OPTIONS_LOCALIZE = {
  en: {
    MULTIPLE_OPTIONS: 'Multiple Options'
  },
  ar: {
    MULTIPLE_OPTIONS: 'اختيارات متعددة'
  }
};

export const DEFAULT_BOT_LANG = 'ar';

export const PERMISSION_STATES = {
  GRANTED: 'granted',
  PROMPT: 'prompt',
  DENIED: 'denied',
  DEFAULT: 'default'
};

export const CONNECT_ONE_PLUGIN = 1;

export const BOT_CURRENCY = (cod, botLang) => ({
  EG: {
    type: 'EGP',
    localized: botLang === 'en' ? `EGP ${cod}` : `${cod} ج.م`
  },
  SA: {
    type: 'SAR',
    localized: botLang === 'en' ? `SAR ${cod}` : `${cod} ر.س`
  }
});

export const ORDER_DETAILS_LOCALIZE = {
  en: {
    payment: 'Payment Method',
    ship_to: 'Ship to',
    arrival: 'Expected delivery',
    show_cart: {
      total_products: 'Total products: ',
      sub_total: 'Subtotal',
      shipping_fees: 'Shipping Fees',
      total: 'Total'
    },
    discount: 'Discount'
  },
  ar: {
    payment: 'طريقة الدفع',
    ship_to: 'الشحن إلى',
    arrival: 'ميعاد التوصيل',
    show_cart: {
      total_products: 'عدد المنتجات: ',
      sub_total: 'المبلغ الإجمالي',
      shipping_fees: 'رسوم الشحن',
      total: 'الإجمالي'
    },
    discount: 'الخصم'
  }
};

export const FILTERCHAT = {
  UNREAD: 'unread',
  READ: 'read',
  DEFAULT: ''
};

export const LAST_MESSAGE_TIME_FORMAT = 'h:mm A';

export const BLOCK_NOTIFICATION_STEPS = [
  {
    id: 1,
    titleId: 'chats_plugins.chats_page.go_to_settings'
  },
  {
    id: 2,
    titleId: 'chats_plugins.chats_page.change_notifications_permission'
  }
];

export const BOT_ACTIONS_MENU = [
  {
    key: SHARE_MEDIA,
    Icon: MediaIcon,
    title: fmt({
      id: 'chats_plugins.chats_page.share_media'
    })
  },
  {
    key: ADD_PRODUCT,
    Icon: Product,
    title: fmt({
      id: 'chats_plugins.chats_page.add_products_cart'
    })
  },
  {
    key: SEND_CART,
    Icon: ShoppingCart,
    title: fmt({
      id: 'chats_plugins.chats_page.send_cart'
    }),
    isNew: false,
    tooltipTitle: fmt({
      id: `chats_plugins.chats_page.disabled_send_cart`
    })
  },
  {
    key: COLLECT_CUSTOMER_INFO,
    Icon: CollectInfo,
    title: fmt({
      id: 'chats_plugins.chats_page.collect_customer_info'
    }),
    isNew: false
  },
  {
    key: COLLECT_SHIPPING_INFO,
    Icon: Location,
    title: fmt({
      id: 'chats_plugins.chats_page.collect_shipping_info'
    }),
    isNew: false,
    tooltipTitle: fmt({
      id: 'chats_plugins.chats_page.enable_send_card'
    })
  }
];

export const IS_UPSELLING_CHANNELS_MODAL_VIEWED =
  'isUpsellingChannelsModalViewed';

export const LOCALIZE_VIEW_DETAILS = {
  en: {
    price: 'PRICE',
    description: 'DESCRIPTION',
    multipleOptions: 'It has multiple options.'
  },
  ar: {
    price: 'السعر',
    description: 'الوصف',
    multipleOptions: 'يحتوي على العديد من الخيارات'
  }
};

export const MANUAl_CHAT = 'manual';
export const AUTOMATE_CHAT = 'automate';

export const CHAT_MODES_OPTIONS = [
  {
    id: MANUAl_CHAT,
    optionId: 'chats_plugins.chats_page.manual_chat',
    descriptionId: 'chats_plugins.chats_page.recommend_manual_chats'
  },
  {
    id: AUTOMATE_CHAT,
    optionId: 'chats_plugins.chats_page.autmate_chat',
    descriptionId: 'chats_plugins.chats_page.recommended_automate_chats'
  }
];

export const CHAT_MODES_GIF = {
  manual: {
    merchant: ManualFlowMerchantManualGif,
    costumer: ManualFlowCustomerManualGif
  },
  automate: {
    merchant: MerchantManualGif,
    costumer: CustomerManualGif
  }
};

export const EMPTY_STATE_NOT_CONNECTED = {
  messenger: {
    icon: MessengerPlatformIcon,
    titleId: 'chats_plugins.install_plugins.connect_fb',
    descriptionId: 'chats_plugins.install_plugins.connect_fb_account'
  },
  instagram: {
    icon: InstagramPlatformIcon,
    titleId: 'chats_plugins.install_plugins.connect_instagram_page',
    descriptionId:
      'chats_plugins.install_plugins.connect_instagram_account_to_start_chat'
  }
};

export const FILTER_BY_ASSIGN = {
  ME: 'me',
  UNASSIGNED: 'unassigned',
  ALL: 'all'
};

export const ALL_CONVERSATION_ACTIONS = [
  {
    labelId: 'chats_plugins.chats_page.all_conversations',
    key: FILTER_BY_ASSIGN.ALL
  },
  {
    labelId: 'chats_plugins.chats_page.my_conversations',
    key: FILTER_BY_ASSIGN.ME
  },

  {
    labelId: 'chats_plugins.chats_page.unassigned',
    key: FILTER_BY_ASSIGN.UNASSIGNED
  }
];

export const ASSIGN_MEMBER_DROPDOWN_ACTIONS = {
  addMember: 'add member',
  unassign: 'unassign member',
  assignMember: 'Assign Member'
};

export const CHAT_LIST_EMPTY_STATE = {
  noChatsWithFIlter: {
    titleID: 'chats_plugins.chats_page.no_conversations',
    descriptionId: 'chats_plugins.chats_page.conversations_will_appear_here',
    buttonId: 'chats_plugins.chats_page.view_all_conversations'
  },
  noChatsWithOutFilter: {
    titleID: 'chats_plugins.chats_page.no_conversations_sent',
    descriptionId: 'chats_plugins.chats_page.start_conversation',
    buttonId: 'chats_plugins.install_plugins'
  }
};

export const PRODUCT_CARD_ACTIONS = {
  ADD: 'ADD_TO_CART',
  REMOVE: 'REMOVE_ITEM'
};

export const ACTIVE = 'Active';

export const MANAGE_CART_PANELS_KEYS = {
  ADDRESS: 'address',
  NOTES: 'notes'
};

export const CHAT_MESSAGES_REQUEST_LIMIT = 50;
export const CHAT_LIST_REQUEST_LIMIT = 50;

export const LOCALIZE_COLLECT_INFO = {
  en: {
    manual: 'Collect customer address manually',
    bot: 'Let Sllr BOT collect customer address'
  },
  ar: {
    manual: 'جمع عنوان العميل بنفسك',
    bot: 'دع سلر بوت يجمع عنوان العميل'
  }
};

export const ADD_TO_CART_STATUS = {
  ADD: 'add',
  DEFAULT: 'default'
};

export const MESSAGE_TYPES = {
  NEW_MESSAGE: 'NEW_MESSAGE',
  CHAT_UPDATE: 'STATUS_UPDATE'
};

export const COLLECT_ADDRESS_SOURCE = {
  ACTION_MENU: 'Actions_Menu',
  MESSAGE_CTA: 'Message_CTA'
};

export const SAVED_REPLIES_STEPS = {
  DEFAULT: 'default',
  ADD: 'add',
  DELETE: 'delete'
};

export const SAVED_REPLIES_ACTIONS = {
  ADD: 'add',
  DELETE: 'delete'
};

export const BOT_CONFIG = {
  WELCOME_MESSAGE: '1'
};

export const FREE_BOT_LOCALIZED = {
  en: 'FREE',
  ar: 'مجاناً'
};

export const LEARN_MORE_LINKS = {
  EN: 'https://chats.sllr.co/?utm_source=interested_users&utm_medium=referral&utm_campaign=interested_users',
  AR: 'https://chats.sllr.co/ar/?utm_source=interested_users&utm_medium=referral&utm_campaign=interested_users'
};

const localize_bot_message_key = 'chats_plugins.chats_page.bot_preview';

export const BOT_PREVIEW_MESSAGE_CODE = {
  2: `${localize_bot_message_key}.welcome_message`,
  3: `${localize_bot_message_key}.how_can_help_u`,
  5: `${localize_bot_message_key}.out_team_will_be_here`,
  7: `${localize_bot_message_key}.product_added_bag`,
  9: `${localize_bot_message_key}.order_summary`,
  10: `${localize_bot_message_key}.showing_shopping_bag`,
  11: `${localize_bot_message_key}.showing_shopping_bag`,
  13: `${localize_bot_message_key}.what_you_like_to_add`,
  14: `${localize_bot_message_key}.empty_shopping_bag`,
  16: `${localize_bot_message_key}.item_removed_from_bag`,
  18: `${localize_bot_message_key}.showing_product_options`,
  19: `${localize_bot_message_key}.showing_product_options`,
  21: `${localize_bot_message_key}.bot_collecting_address`,
  22: `${localize_bot_message_key}.bot_collecting_address`,
  25: `${localize_bot_message_key}.bot_collecting_address`,
  27: `${localize_bot_message_key}.bot_collecting_address`,
  29: `${localize_bot_message_key}.bot_collecting_address`,
  31: `${localize_bot_message_key}.perfect_order_summary`,
  32: `${localize_bot_message_key}.showing_order_summary`,
  33: `${localize_bot_message_key}.showing_order_summary`,
  35: `${localize_bot_message_key}.sales_order_created`,
  36: `${localize_bot_message_key}.how_many`,
  38: `${localize_bot_message_key}.invalid_quantity`,
  42: `${localize_bot_message_key}.bot_collecting_address`,
  43: `${localize_bot_message_key}.bot_collecting_address`,
  44: `${localize_bot_message_key}.bot_collecting_address`,
  48: `${localize_bot_message_key}.bot_collecting_address`,
  51: `${localize_bot_message_key}.bot_collecting_address`,
  53: `${localize_bot_message_key}.bot_collecting_address`,
  55: `${localize_bot_message_key}.showing_product_details`,
  56: `${localize_bot_message_key}.facing_any_problems`,
  59: `${localize_bot_message_key}.which_product_want`,
  62: `${localize_bot_message_key}.shop_our_products`,
  64: `${localize_bot_message_key}.language_changed`,
  66: `${localize_bot_message_key}.i_want_this`
};

export const META_24H_LINKS = {
  meta_Inbox: 'https://business.facebook.com/latest/inbox/all',
  learn_more:
    'https://developers.facebook.com/docs/messenger-platform/policy/policy-overview'
};

export const SHARED_CONTENT_TYPE = {
  FALLBACK: 'fallback',
  SHARE: 'share',
  IG_REEL: 'ig_reel'
};

export const COLLECT_ADDRESS_TYPE = {
  MANUALLY: 'MANUALLY',
  BOT: 'BOT',
  DEFAULT: 'DEFAULT'
};

export const DEFAULT_ID = 1;

export const CHAT_SEEN = 'CHAT_SEEN';
export const CHAT_UNSEEN = 'CHAT_UNSEEN';

export const CHAT_STATUS = ['open', 'done', 'follow-up'];

export const CHAT_COUNTER_STATE = {
  CHAT_SEEN: {
    count: 0,
    operator: '-'
  },
  CHAT_UNSEEN: {
    count: 1,
    operator: '+'
  }
};

export const STEPS = {
  FIRST: 1,
  SECOND: 2,
  THIRD: 3
};

export const TOTAL_ANNOUNCEMENT_STEPS = 3;

export const GOOGLE_PLAY_LINK = 'https://bit.ly/SllrChat';
export const APP_STORE_LINK = 'https://apple.co/42HNFaL';
export const WHATS_APP_CONTACT = 'https://wa.me/+201094574817';

export const DISCOUNT_TYPE = {
  FEES: 'fees',
  DISCOUNT: 'discount'
};
